export enum DiceResult {
    Crown = 1,
    Mask = 2,
    Jail = 3,
    Aim = 4,
    House = 5,
    Mystery = 6
}
